import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface PageHeaderProps {
  label: string
  title: string
  description?: string
  image: string
  imageAlt?: string
  breadcrumb: string
}

export default function PageHeader({ label, title, description, image, imageAlt, breadcrumb }: PageHeaderProps) {
  const { t } = useTranslation()

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src={image}
          alt={imageAlt || title}
          title={`${title} — Shabi Media`}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/55 to-black/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/40" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-32 pb-16 md:pt-40 md:pb-24">
        <nav className="flex items-center gap-2 text-xs md:text-sm text-background-300 mb-6">
          <Link to="/" className="hover:text-primary-300 transition-colors cursor-pointer">
            {t('nav.home')}
          </Link>
          <i className="ri-arrow-right-s-line text-base" />
          <span className="text-primary-300">{breadcrumb}</span>
        </nav>

        <div className="flex items-center gap-3 mb-5">
          <span className="h-px w-10 bg-primary-400" />
          <span className="section-label text-primary-300 text-[11px] md:text-xs font-medium">{label}</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl font-semibold text-background-50 leading-[1.08] max-w-4xl">
          {title}
        </h1>

        {description && (
          <p className="mt-5 md:mt-6 text-base md:text-lg text-background-200/90 max-w-2xl leading-relaxed">
            {description}
          </p>
        )}
      </div>
    </section>
  )
}